import React, { Component } from 'react'

export default class FileDownloader extends Component {
	constructor(){
    super()
    this.state = {
      mounted: false
    }
  }
	getURL = () => {
		const { fileString, contentType='', charset = 'utf-8' } = this.props
		return `data:${contentType};charset=${charset},${encodeURIComponent(fileString)}`
	}
	download = () => {
    if(window.navigator.msSaveOrOpenBlob){
			window.navigator.msSaveOrOpenBlob(this.props.blob, this.props.fileName);
		}else{
			this.setState({
				mounted: true
			}, () => {
				this.link.click()
				this.setState({
					mounted: false
				})
			})
		}
  }
	render() {
		const { fileName="downloaded", href } = this.props
		return (
			this.state.mounted ?
			<a
				href={href ? href : this.getURL()}
				ref={link => {
					this.link = link
				}}
				style={{
					visibility: 'hidden',
					opacity: 0,
					width: 1,
					height: 1,
					position: 'fixed',
					right: -1,
					bottom: -1
				}}
				onClick={e=>{e.stopPropagation()}}
        download={fileName}
				// target="_blank"
			>
			</a>
			: null
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/FormManager/FileDownloader.js